var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3940",
    "data-name": "Group 3940",
    transform: "translate(-1428 -718)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5506",
    "data-name": "Rectangle 5506",
    width: 35,
    height: 35,
    rx: 5,
    transform: "translate(1428 718)",
    fill: "#c2fae5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3744",
    "data-name": "Group 3744",
    transform: "translate(1437.625 726.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noun-delet-4151532",
    d: "M141.939,67.964a2.586,2.586,0,0,0,2.586,2.586h6.464a2.586,2.586,0,0,0,2.586-2.586V57.622h1.293a.646.646,0,1,0,0-1.293h-3.29a3.879,3.879,0,0,0-7.641,0h-3.29a.646.646,0,1,0,0,1.293h1.293Zm5.818-13.575a2.586,2.586,0,0,1,2.5,1.939h-5a2.586,2.586,0,0,1,2.5-1.939Zm-3.232,3.232h7.757V67.964a1.293,1.293,0,0,1-1.293,1.293h-6.464a1.293,1.293,0,0,1-1.293-1.293V57.622Zm.646,9.05V60.207a.646.646,0,1,1,1.293,0v6.464a.646.646,0,1,1-1.293,0Zm3.878,0V60.207a.646.646,0,1,1,1.293,0v6.464a.646.646,0,1,1-1.293,0Z",
    transform: "translate(-140 -53.12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_Icon.8aa3a83069419110e2aa2cea837324e8.svg";
export { ForwardRef as ReactComponent };